// config.js
export const API_BASE_URL = "http://integrations.riolab.com:30400";
// export const MAPBOX_ACCESS_TOKEN =
export const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoiZmVsaXBlNCIsImEiOiJlZDkyMTU4YWE4YmI2ZmMxYTMxYmU1YTQwZmQ2ZjkxMSJ9.A8tczGhX5JDhBZDn_B2AhQ";
export const MAPBOX_STYLE = "mapbox://styles/felipe4/cm1ikr59f009w01p61ltf5d8k";
